import { call, put, select } from 'redux-saga/effects'
import { partiallyApplyProjectsAction } from 'actions/projectActions'
import { getProjectsExcept } from 'sagas/setupProjectsSaga/findBySelector'
import { databaseSelector } from 'selectors'

export default function * deferApplyProjects(id) {
  const { database } = yield select(databaseSelector)
  const projects = yield call(getProjectsExcept, database, id)
  yield put(partiallyApplyProjectsAction(projects))
}



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/deferApplyProjects.js